export default __webpack_public_path__ + "static/media/asset 23.39382e93.jpeg";